/**
 * Provides facility for displaying snackbar message. This module provides a globally
 * available function called showSnackbar which initiates the display of a message.
 * The HTML container is provided in the footer so as to be available in every page.
 *
 */
const snackbar = (function () {
    const _settings = {
        snackbarContainer: document.querySelector(".o-snackbar__container"),
    };

    var snackbarTimeoutID;
    /**
     * Display the snackbar message
     *
     * @param {string} message
     * @param {string} messageStyle     success, error, warning
     * @param {number} time    number of milliseconds to show message
     * @param {boolean} removeExisting    flag to indicate if existing messages should be removed first
     */
    function showSnackbar(message, messageStyle = "", time = 3000, removeExisting = false) {
        if (
            typeof message === "string" &&
            message.length > 0 &&
            typeof time === "number" &&
            typeof removeExisting === "boolean" &&
            _settings.snackbarContainer
        ) {
            /**
             * If request is to remove existing messages and there are at least 1 existing message,
             * remove all existing messages by removing the child nodes.
             */
            if (removeExisting === true && _settings.snackbarContainer.children.length > 0) {
                _settings.snackbarContainer.replaceChildren();
            }

            if (messageStyle !== "success" && messageStyle !== "error" && messageStyle !== "warning") {
                messageStyle = "";
            }
            /**
             * Create new node for snackbar item with class and message, then
             * append node to DOM as a child of the snackbar container.
             */
            const snackbarItem = document.createElement("div");
            const snackbarID = Math.floor(Math.random() * 10000);
            snackbarItem.setAttribute("id", snackbarID);
            snackbarItem.classList.add("o-snackbar__item");
            if (messageStyle.length > 0) {
                snackbarItem.classList.add("-" + messageStyle);
            }
            snackbarItem.insertAdjacentHTML(
                "afterbegin",
                `<div class=o-snackbar__closeIcon><a href="javascript:snackbar.closeSnackbar('${snackbarID}');"><span class='a-msIcon -iconSize20px'>close</span></a></div>`
            );

            snackbarItem.insertAdjacentHTML("beforeend", message);

            _settings.snackbarContainer.appendChild(snackbarItem);

            /**
             * Add the "show" class to the new snackbar node. This will
             * start the fade-in amimation to show the new message.
             */
            snackbarItem.classList.add("-show");

            /**
             * After the appropriate time passes, add the "hide" class which will start
             * the fade-out animation. After the animation finishes (0.5s), remove the
             * node from the snackbar container.
             */
            if (time != 0) {
                setTimeout(function () {
                    snackbarItem.classList.add("-hide");
                    // Wait 0.5 seconds to allow fade out before removing item
                    setTimeout(() => {
                        if (_settings.snackbarContainer.contains(snackbarItem)) {
                            _settings.snackbarContainer.removeChild(snackbarItem);
                        }
                    }, 500);
                }, time);
            }
        }
    }

    function closeSnackbar(elementID) {
        const element = document.getElementById(elementID);
        if (element) {
            element.remove();
        }
    }

    return {
        showSnackbar: showSnackbar,
        closeSnackbar: closeSnackbar,
    };
})();
export { snackbar };
